import { DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import { Modal, Space, Form } from 'antd';
import HighlightDropDown from 'components/form/FormUpload/HighlightDropDown';
import HighlightLabel, {
  HighlightLabelProps,
} from 'components/form/FormUpload/HighlightLabel';
import { ImageItemStyle } from 'components/form/FormUpload/styles';
import React, { useState } from 'react';
import { getImageUrl } from 'utils/tools';

export interface ImageItemProps
  extends Pick<HighlightLabelProps, 'formatHightLight' | 'highlightName'> {
  customAction?: (
    src: string,
    setIsFocus?: (e: boolean) => void,
  ) => React.ReactNode;
  onDelete: (src: string) => void;
  src: string;
  type?: 'single' | 'array';
}

export default function ImageItem({
  src,
  customAction,
  onDelete,
  highlightName,
  formatHightLight,
  type,
}: ImageItemProps) {
  const [visible, setVisible] = useState(false);
  const [isFocus, setIsFocus] = useState(false);

  return (
    <>
      <ImageItemStyle isFocus={isFocus}>
        {String(src).toLowerCase()?.includes('mp4') ? (
          <video src={getImageUrl(src)} controls />
        ) : (
          <img src={getImageUrl(src)} alt="imge" />
        )}
        {type !== 'single' && (
          <Form.Item noStyle shouldUpdate>
            {() => (
              <div className="highlight-label">
                <HighlightLabel
                  src={src}
                  formatHightLight={formatHightLight}
                  highlightName={highlightName}
                />
              </div>
            )}
          </Form.Item>
        )}
        <div className="overlay-view">
          <div className="d-flex flex-center flex-1">
            <Space>
              <EyeOutlined onClick={() => setVisible(true)} />
              <DeleteOutlined onClick={() => onDelete(src)} />
            </Space>
          </div>
          {type !== 'single' && (
            <>
              {!!customAction && (
                <div className="custom-action">
                  {customAction?.(getImageUrl(src), setIsFocus)}
                </div>
              )}
              {!customAction && highlightName && (
                <div className="custom-action">
                  <HighlightDropDown
                    setIsFocus={setIsFocus}
                    src={src}
                    highlightName={highlightName}
                  />
                </div>
              )}
            </>
          )}
        </div>
      </ImageItemStyle>
      {!!visible && (
        <Modal footer={null} open={visible} onCancel={() => setVisible(false)}>
          {/* <img src={src} className="w-full" /> */}
          {src?.includes('mp4') ? (
            <video src={getImageUrl(src)} controls className="w-full" />
          ) : (
            <img src={getImageUrl(src)} alt="imge" className="w-full" />
          )}
        </Modal>
      )}
    </>
  );
}
